/* global ksApp */

import Cookies from 'js-cookie';
import toast from './toast';

const personalize = () => {
  const form = document.querySelector('.js-personalize-form');
  const formWrapper = document.querySelector('.js-personalize-form-wrapper');
  const confirmation = document.querySelector('.js-personalize-confirmation');
  const body = document.querySelector('body');
  const hiddenClass = 'u-hidden';

  const handleFormSave = event => {
    event.preventDefault();
    const data = [];
    const formElements = event.currentTarget
      ? Array.from(event.currentTarget.elements)
      : [];

    formElements.forEach(element => {
      if (element.nodeName === 'INPUT' && element.checked) {
        if (!data[element.name]) {
          data[element.name] = [];
        }
        data[element.name].push(element.value);
      }
    });

    const ajaxURL = document.querySelector('meta[name="adjx"]').content;
    const ajaxData = {
      action: 'ks_save_personalized_data',
      ...data,
    };

    const ajaxParameters = Object.entries(ajaxData)
      .map(param => param.join('='))
      .join('&');

    const xhr = new XMLHttpRequest();
    xhr.open('POST', ajaxURL, true);

    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');

    xhr.onload = () => {
      const response = JSON.parse(xhr.response);

      const anchor = document.querySelector('.js-header');
      const offset = anchor?.getBoundingClientRect();
      const scrollTop =
        (window.pageYOffset || document.documentElement.scrollTop) - 20;
      window.scroll({
        top: scrollTop + offset.top,
        behavior: 'smooth',
      });

      if (response.success && response.cookie) {
        confirmation.classList.remove(hiddenClass);
        formWrapper.classList.add(hiddenClass);
      }

      if (!response.cookie) {
        const toastWrapper = document.createElement('div');
        toastWrapper.innerHTML = response.message;
        body.append(toastWrapper);

        if (response.success && response.redirect) {
          setTimeout(() => {
            window.location.href = response.redirect;
          }, 3000);
        }
      }

      toast(); // bind close event
    };

    xhr.onerror = response => {
      // eslint-disable-next-line no-console
      console.error(response);
    };

    xhr.send(ajaxParameters);
  };

  if (form) {
    form.addEventListener('submit', handleFormSave);
  }

  if (Cookies.get('ks_personalized_query_string') && ksApp?.personalization) {
    ksApp.personalization.forEach(item => {
      const link = document.querySelector(`a[href="${item.target}"]`);
      if (link) {
        link.setAttribute('href', item.replace);
      }
    });
  }
};

export default personalize;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/personalize.js